<form>
    <div>
        <h3>{{ getMigratingToHeader() }}</h3>
        <button mat-button type="button" (click)="handleNumberOfLots(1)">Add a {{ migrationLotType === LOT_TYPE_ENUM.TerracedBlock ? 'Block' : 'Lot' }}</button>
        @if (numberOfLotsToAdd > 1) {
            <button mat-button type="button" (click)="handleNumberOfLots(-1)">Remove a {{ migrationLotType === LOT_TYPE_ENUM.TerracedBlock ? 'Block' : 'Lot' }}</button>
        }
        @if (migrationLotType === LOT_TYPE_ENUM.TerracedBlock) {
            <button mat-button type="button" (click)="handleNumberOfUnits(1)">Add a Unit</button>
            @if (numberOfUnitsToAdd > 2) {
                <button mat-button type="button" (click)="handleNumberOfUnits(-1)">Remove a Unit</button>
            }
        }
    </div>
</form>
